export const CONSOLIDATED_SHIPPING_COPY = 'Bundled shipping'
